import { LivedataService, LivedataProvider, HttpService } from '@lk/api'

export const makeLivedataService = (http: HttpService, baseUrl: string) =>
  new LivedataService(new LivedataProvider(http, baseUrl))
